__turbopack_context__.v({
  "caption": "styles-module-scss-module__v-jd_W__caption",
  "root": "styles-module-scss-module__v-jd_W__root",
});
